import downloadFile from '../../../Services/downloadFile'

export default () => (dispatch) => {

  dispatch(downloadFile())

}
